function login(quiz_email, password, btn_text) {
    const formdata = new FormData();
    formdata.append("customer[email]", quiz_email);
    formdata.append("customer[password]", password);
    formdata.append("form_type", "customer_login");
    formdata.append("utf8\n", "✓");

    const requestOptions = {
      method: "POST",
      body: formdata,
      redirect: "follow"
    };

    fetch("/account/login", requestOptions)
      .then((response) => response.text())
      .then((result) => {
        document.querySelector('.QuizellLoginError').style.display = 'none';
          if (result.includes('Invalid login credentials')) {
            //   document.querySelector('.QuizellLoginError p').innerHTML = '{{ 'quiz.invalid_login' | t }}';
              document.querySelector('.QuizellLoginError p').innerHTML = window.quiz.invalid_login;
              document.querySelector('.QuizellLoginError').style.display = 'block';
              document.getElementById('QuizellLogin').innerHTML = btn_text;
              document.getElementById('QuizellLogin').disabled = false;
          } else if (result.includes('Incorrect email or password.')) {
              // document.querySelector('.QuizellLoginError p').innerHTML = '{{ 'quiz.incorrect_email_pwd' | t }}';
              document.querySelector('.QuizellLoginError p').innerHTML = window.quiz.incorrect_email_pwd;
              document.querySelector('.QuizellLoginError').style.display = 'block';
              document.getElementById('QuizellLogin').innerHTML = btn_text;
              document.getElementById('QuizellLogin').disabled = false;
          } else {
              quizObject.customer_email = quiz_email;
              loadResultPage();
              document.getElementById('QuizellLogin').innerHTML = btn_text;
              document.getElementById('QuizellLogin').disabled = false;
          }
      }).catch((error) => console.error(error));
}

document.addEventListener('click', function(e) {
    if(e.target && e.target.id == 'QuizellLogin') {
      var btn_text = e.target.innerHTML;
      e.target.innerHTML = '<svg class="ch-spinner" viewBox="0 0 50 50"><circle class="ch-path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle></svg>';
      e.target.disabled = true;
      var quiz_email = document.getElementById('CustomerEmailQuizell').value;
      var quiz_pwd = document.getElementById('CustomerPasswordQuizell').value;
      login(quiz_email, quiz_pwd, btn_text);
    }
});

function register(quiz_email, password, firstName, AcceptsMarketing, btn_text) {
  const formdata = new FormData();
  formdata.append("customer[email]", quiz_email);
  formdata.append("customer[password]", password);
  formdata.append("customer[first_name]", firstName);
  formdata.append("customer[accepts_marketing]", AcceptsMarketing);
  formdata.append("form_type", "create_customer");
  formdata.append("utf8\n", "✓");

  const requestOptions = {
    method: "POST",
    body: formdata,
    redirect: "follow"
  };

  fetch("/account", requestOptions)
    .then((response) => response.text())
    .then((result) => {
      if (result.indexOf('This email address is already associated with an account. If this account is yours, you can') !== -1) {
        // document.querySelector('.QuizellRegisterError').innerHTML = '<p>{{ 'quiz.email_exsits' | t }}</p>';
        document.querySelector('.QuizellRegisterError').innerHTML = window.quiz.email_exsits;
        document.querySelector('.QuizellRegisterError').style.display = 'block';
      } else if (result.indexOf('Email is invalid.') !== -1) {
        // document.querySelector('.QuizellRegisterError').innerHTML = '<p>{{ 'quiz.email_invalid' | t }}</p>';
        document.querySelector('.QuizellRegisterError').innerHTML = window.quiz.email_invalid;
        document.querySelector('.QuizellRegisterError').style.display = 'block';
      } else if (result.indexOf('Email can&#39;t be blank') !== -1) {
        // document.querySelector('.QuizellRegisterError').innerHTML = '<p>{{ 'quiz.email_valid' | t }}</p>';
        document.querySelector('.QuizellRegisterError').innerHTML = window.quiz.email_valid;
        document.querySelector('.QuizellRegisterError').style.display = 'block';
      } else if (result.indexOf('Password can&#39;t be blank.') !== -1) {
        // document.querySelector('.QuizellRegisterError').innerHTML = '<p>{{ 'quiz.password_valid' | t }}</p>';
        document.querySelector('.QuizellRegisterError').innerHTML = window.quiz.password_valid;
        document.querySelector('.QuizellRegisterError').style.display = 'block';
      } else if (result.indexOf('Password must be different. For the security of your account you cannot use this password.') !== -1) {
        // document.querySelector('.QuizellRegisterError').innerHTML = '<p>{{ 'quiz.password_security' | t }}</p>';
        document.querySelector('.QuizellRegisterError').innerHTML = window.quiz.password_security;
        document.querySelector('.QuizellRegisterError').style.display = 'block';
      } else {
        console.log('success');
        quizObject.customer_email = quiz_email;
        loadResultPage();
      }
      document.getElementById('QuizellRegister').innerHTML = btn_text;
      document.getElementById('QuizellRegister').disabled = false;
    }).catch((error) => console.error(error));
}

document.addEventListener('click', function(e) {
  if (e.target && e.target.id == 'QuizellRegister') {
    var btn_text = e.target.innerHTML;
    e.target.innerHTML = '<svg class="ch-spinner" viewBox="0 0 50 50"><circle class="ch-path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle></svg>';
    e.target.disabled = true;
    var quiz_name = document.getElementById('QuizellRegisterForm-FirstName').value;
    var quiz_email = document.getElementById('QuizellRegisterForm--email').value;
    var quiz_pwd = document.getElementById('QuizellRegisterForm--password').value;
    var quiz_conf_pwd = document.getElementById('QuizellRegisterForm-confirm-password').value;

    document.querySelector('.QuizellRegisterError').style.display = 'none';
    var error_html = '';

    if (quiz_name == '') {
    //   error_html += '<p>{{ 'quiz.first_name_valid' | t }}</p>';
      error_html += `<p>${window.quiz.first_name_valid}</p>`;
    }
    if (quiz_email == '') {
      // error_html += '<p>{{ 'quiz.email_valid' | t }}</p>';
      error_html += `<p>${window.quiz.email_valid}</p>`;
    }
    if (quiz_pwd == '') {
      // error_html += '<p>{{ 'quiz.password_valid' | t }}</p>';
      error_html += `<p>${window.quiz.password_valid}</p>`;
    }
    if (quiz_conf_pwd == '') {
      // error_html += '<p>{{ 'quiz.confirm_password_valid' | t }}</p>';
      error_html += `<p>${window.quiz.confirm_password_valid}</p>`;
    }

    if (quiz_pwd != '' && quiz_conf_pwd != '' && quiz_pwd != quiz_conf_pwd) {
      // error_html += '<p>{{ 'quiz.confirm_password_not_match' | t }}</p>';
      error_html += `<p>${window.quiz.confirm_password_not_match}</p>`;
    }
    if (error_html == '') {
      if (document.getElementById('QuizellRegisterForm-marketing').checked) {
        var quiz_marketing = true;
      } else {
        var quiz_marketing = false;
      }
      register(quiz_email, quiz_pwd, quiz_name, quiz_marketing, btn_text);
    } else {
      document.querySelector('.QuizellRegisterError').innerHTML = error_html;
      document.querySelector('.QuizellRegisterError').style.display = 'block';
      document.getElementById('QuizellRegister').innerHTML = btn_text;
      document.getElementById('QuizellRegister').disabled = false;
    }
  }
});